import * as React from "react";

interface FlightIconProps {
  className?: string;
  color?: string;
}

export const FlightIcon: React.FC<FlightIconProps> = ({ className, color = "currentColor" }) => (
  <svg 
    width="14" 
    height="14" 
    viewBox="0 0 14 14" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden
  >
    <path 
      d="M5.99874 5.87021L0.726237 3.61208C0.446376 3.49139 0.277626 3.28764 0.219987 3.00083C0.162209 2.71389 0.241237 2.4625 0.45707 2.24667L0.726237 1.96958C0.821376 1.87445 0.934084 1.80576 1.06436 1.76354C1.19478 1.72132 1.32999 1.71146 1.46999 1.73396L8.84978 3.02729L11.4489 0.415001C11.7258 0.138334 12.0634 0 12.4619 0C12.8603 0 13.1979 0.138334 13.4746 0.415001C13.7514 0.691668 13.8898 1.02931 13.8898 1.42792C13.8898 1.82639 13.7514 2.16396 13.4746 2.44063L10.8752 5.05271L12.1558 12.4198C12.1782 12.5598 12.1704 12.6971 12.1325 12.8317C12.0946 12.9663 12.028 13.0811 11.9329 13.1763L11.6558 13.4325C11.44 13.6483 11.1865 13.7296 10.8954 13.6763C10.6043 13.6228 10.3983 13.4561 10.2775 13.1763L8.03228 7.89563L5.69103 10.2242L6.14124 12.8156C6.16374 12.9278 6.1595 13.0365 6.12853 13.1417C6.09756 13.2469 6.04145 13.3402 5.9602 13.4215L5.6702 13.7033C5.50783 13.8658 5.31367 13.9289 5.0877 13.8925C4.86172 13.8563 4.69263 13.7372 4.5804 13.5352L3.10769 10.7948L0.367278 9.32208C0.165334 9.20986 0.0462366 9.04076 0.00998661 8.81479C-0.0264023 8.58882 0.0366533 8.39465 0.199153 8.23229L0.481028 7.94229C0.562278 7.86104 0.655542 7.80361 0.76082 7.77C0.865959 7.73639 0.974639 7.73076 1.08686 7.75313L3.6654 8.19875L5.99874 5.87021Z" 
      fill={color}
    />
  </svg>
);